import React from "react";
import { connect } from "react-redux";
import { History } from "history";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import Table from "components/Table";
import FieldChooser from "components/FieldChooser";
import TopButtons from "components/TopButtons";
import { IOrderRelation, IMeta, ICommonState } from "models/.";
import { URLS } from "constants/urlConstants";
import OrderActions from "./actions";
import { markAsRead, markAsUnread } from "../app/actions";
import { columns } from "./columns";
import { columnsExcel } from "./columnsExcel";
import OrderSearch from "./partials/OrderSearch";
import { downloadDocuments } from "helpers/download";
import { getSelectedData } from "helpers/common";
import { CUSTOM_SETTINGS } from "constants/.";

interface IProps {
  getOrders: (meta?: IMeta) => void;
  orders: IOrderRelation[];
  meta: IMeta;
  history: History;
  getExportData: () => void;
  roleIds: any[];
  getSelectOptions: () => void;
  statusOptions: any[];
  typeOptions: any[];
}

interface IState extends ICommonState {
  selectedData: any;
}

class Orders extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: "",
      showFieldChooser: false,
      columnsCopy: [],
      checkedRows: {},
      selectedData: []
    };
  }

  public componentDidMount() {
    const { statusOptions, getSelectOptions } = this.props;
    if (!statusOptions || !statusOptions.length) {
      getSelectOptions();
    }
  }

  public handleSelect = selectedOption => {
    const { selectedData } = this.state;
    const { value } = selectedOption;
    const ids = _.map(selectedData, "orderId");

    value === "gelezen" && markAsRead(ids);
    value === "ongelezen" && markAsUnread(ids);
    if (value === "pdf") {
      const documentIds = _.compact(_.map(selectedData, "documentId"));
      downloadDocuments(documentIds, "ORDERS");
      markAsRead(ids);
    }
  };

  public handleFieldChooser = () => {
    this.setState(({ showFieldChooser }) => ({
      showFieldChooser: !showFieldChooser
    }));
  };

  public handleFieldsChange = data => {
    this.setState({ columnsCopy: data });
  };

  public onRowClick = rowData => {
    this.props.history.push(
      `${URLS.ORDERS_URL}/${rowData.Id}?kooptype=${rowData.RoleId}`
    );

    if (!_.get(rowData, "Read", true)) {
      markAsRead([rowData.Id], "Order");
    }
  };

  private onRowSelect = checkedRows => {
    this.setState({
      checkedRows,
      selectedData: getSelectedData(
        this.props.orders,
        checkedRows,
        this.state.selectedData,
        "orderId"
      )
    });
  };

  public render() {
    const {
      orders,
      getOrders,
      meta,
      roleIds,
      statusOptions,
      typeOptions
    } = this.props;
    const {
      showFieldChooser,
      columnsCopy,
      selectedOption,
      checkedRows
    } = this.state;

    return (
      <div id="orders-page">
        <FormattedMessage id="ORDERS" tagName="h1" />
        <OrderSearch
          meta={meta}
          onSearch={getOrders}
          roleIds={roleIds}
          typeOptions={typeOptions}
          statusOptions={statusOptions}
        />
        <TopButtons
          switchUnread={meta.unread}
          handleFieldChooser={this.handleFieldChooser}
          handleSelect={this.handleSelect}
          toggleUnread={() =>
            getOrders({
              ...meta,
              unread: !meta.unread,
              currentPage: 0
            })
          }
          excelColumns={columnsExcel}
          selectedOption={selectedOption}
          getExcelData={() => OrderActions.getExportData(meta.searchString)}
          entityName="ORDERS"
        />
        <Table
          columns={columnsCopy}
          dataSource={orders}
          onRowClick={this.onRowClick}
          meta={meta}
          onQueryChange={getOrders}
          onRowSelect={this.onRowSelect}
          checkedRows={checkedRows}
          pageName={CUSTOM_SETTINGS.orders}
        />
        <FieldChooser
          name="orders"
          visible={showFieldChooser}
          handleFieldChooser={this.handleFieldChooser}
          handleFieldsChange={this.handleFieldsChange}
          columns={columns}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    orders: state.orders.items,
    meta: state.orders.meta,
    roleIds: state.app.roleIds,
    statusOptions: state.orders.statusOptions,
    typeOptions: state.orders.typeOptions
  }),
  {
    getOrders: OrderActions.getOrders,
    getSelectOptions: OrderActions.getSelectOptions
  }
)(Orders);
